import * as React from 'react';
import visionOSSelected from '../../../assets/visionos-selected.svg';
import visionOSUnselected from '../../../assets/visionos-unselected.svg';
import visionOSDisabledSelected from '../../../assets/visionos-disabled-selected.svg';
import visionOSDisabledUnselected from '../../../assets/visionos-disabled-unselected.svg';
import { IconProps } from '../../typescriptHelpers';

interface VisionOSIconProps extends IconProps {
    isSelected: boolean;
    isDisabledTreatment: boolean;
}

const VisionOSIcon: React.FC<VisionOSIconProps> = (props: VisionOSIconProps) => {
    let sourceImage = props.isSelected ? visionOSSelected : visionOSUnselected;
    if (props.isDisabledTreatment) {
        sourceImage = props.isSelected ? visionOSDisabledSelected : visionOSDisabledUnselected;
    }

    return <img src={sourceImage} width={props.width} height={props.height} />;
};

export default VisionOSIcon;
